import { render } from "./App.vue?vue&type=template&id=7d233e85"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7d233e85&lang=scss"
script.render = render

export default script